import { render, staticRenderFns } from "./ArticleFolder.vue?vue&type=template&id=70779547&"
import script from "./ArticleFolder.vue?vue&type=script&lang=ts&"
export * from "./ArticleFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports